import React, { createContext } from 'react'
import { BaseContextState, BaseContextProvider } from '../BaseContext'
import ILanguage from '../../interfaces/ILanguage'
import { SearchRequest } from '../../services/api/interfaces/ApiRequest'
import { languageList } from '../../services/api'

interface LanguageState extends BaseContextState {
  languages: Array<ILanguage> | null
}

export interface LanguageContextData extends LanguageState {
  resetErrors: Function,
  requestLanguageList: (args: SearchRequest) => Promise<any>,
}

// Create context
const { Provider, Consumer } = createContext({} as LanguageContextData)

// Export consumer
export const LanguageConsumer = Consumer

export class LanguageProvider extends BaseContextProvider {
  state: LanguageState = {
    languages: null,
  }

  lastListPayload: SearchRequest | null = null

  /**
   * Make api request for language list
   * 
   * @param {SearchRequest} payload 
   */
  requestLanguageList = (payload: SearchRequest) => {
    return new Promise((resolve, reject) => {
      this.setState({
        fetching: true,
        error: null
      }, async () => {
        this.lastListPayload = payload
        const response = await languageList(payload)
  
        // Process our response
        this.processResponse(response, { 
          paginate: {
            destination: 'languages'
          },
        })

        if (this.state.success) {
          resolve(this.state.languages)
        } else {
          reject(this.state.error)
        }
      })
    })
  }

  render() {
    return (
      <Provider
        value={{
          // States
          ...this.state,

          // Dispatches
          resetErrors: this.resetErrors,
          requestLanguageList: this.requestLanguageList
        }}
      >
        {this.props.children}
      </Provider>
    )
  }
}
